import React from "react";

export default function PolicyPage() {
  return (
    <div className="cs_error cs_center cs_gray_bg_1">
      <div className="container cs_policy">
        <h3>Политика конфиденциальности</h3>
        <p>
          <strong>ООО "АК АЮ КЛИНИК"</strong> (далее — "Клиника") уважает право
          пользователей на конфиденциальность и соблюдает Федеральный закон РФ
          №152-ФЗ «О персональных данных».
        </p>

        <h4>1. Общие положения</h4>
        <p>
          Настоящая Политика регулирует порядок обработки и защиты персональных
          данных пользователей, оставленных на сайте{" "}
          <a href="https://akau-clinic.ru">akau-clinic.ru</a>.
        </p>

        <h4>2. Состав персональных данных</h4>
        <p>Мы можем собирать следующие данные:</p>
        <ul>
          <li>ФИО</li>
          <li>Номер телефона</li>
          <li>Адрес электронной почты</li>
          <li>
            Другие данные, предоставленные добровольно (через форму записи, чат,
            WhatsApp и т.д.)
          </li>
        </ul>

        <h4>3. Цели сбора данных</h4>
        <p>Ваши данные используются исключительно для:</p>
        <ul>
          <li>Записи на приём к врачу</li>
          <li>Связи с вами для подтверждения записи</li>
          <li>Ответа на ваши вопросы</li>
          <li>Улучшения качества обслуживания</li>
        </ul>

        <h4>4. Правовая основа</h4>
        <p>
          Обработка данных осуществляется на основании вашего добровольного
          согласия, предоставленного путём отправки данных через формы на сайте.
        </p>

        <h4>5. Защита данных</h4>
        <p>
          Клиника принимает необходимые организационные и технические меры для
          защиты персональных данных от утечки, несанкционированного доступа и
          иных противоправных действий.
        </p>

        <h4>6. Передача третьим лицам</h4>
        <p>
          Ваши персональные данные не передаются третьим лицам, за исключением
          случаев, предусмотренных законом.
        </p>

        <h4>7. Хранение данных</h4>
        <p>
          Данные хранятся не дольше, чем это необходимо для целей обработки,
          либо до отзыва вашего согласия.
        </p>

        <h4>8. Права пользователя</h4>
        <p>Вы имеете право:</p>
        <ul>
          <li>Запрашивать информацию о ваших данных</li>
          <li>Требовать их изменения или удаления</li>
          <li>Отозвать согласие на обработку</li>
        </ul>

        <h4>9. Контактная информация</h4>
        <p>
          По всем вопросам, связанным с персональными данными, вы можете
          обратиться:
        </p>
        <p>
          Email:
          <a href="mailto:zafarzhon10@gmail.com">zafarzhon10@gmail.com</a>
          <br />
          Телефон: <a href="tel:+79585020555">+7 (958) 502-05-55</a>
        </p>

        <p>
          Дата публикации: <strong>17 июля 2025 г.</strong>
        </p>
      </div>
    </div>
  );
}
